import React, { useState } from "react"
import SlickSlider from "react-slick"
import FeatureCard from "../Cards/FeatureCard"
import VideoModal from "../VideoModal"
import "./index.scss"

export default function FeatureSlider({ component }) {
  const { headline, featuredSlides, background } = component
  const bg = background && background[0]?.backgroundColor

  const sliderSettings = {
    dots: true,
    arrows: false,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    variableWidth: true,
    appendDots: dots => (
      <>
        <div className={`dots feature-dots ${"_" + bg?.replace("#", "")}`}>
          <ul>{dots}</ul>
        </div>
      </>
    ),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
    ],
  }

  //----- Video Modal States and Handlers
  const [modalOpen, setModalOpen] = useState(false)
  const [videoCode, setVideoCode] = useState("")
  const [vidSource, setVidSource] = useState("")

  const handleModal = e => {
    e.target.getAttribute("data-hasvid") === "true" && setModalOpen(true)
    setVideoCode(e.target.getAttribute("data-vidlink"))
    setVidSource(e.target.getAttribute("data-vidsource"))
  }

  return (
    <>
      {modalOpen && (
        <VideoModal
          open={modalOpen}
          vidSource={vidSource}
          videoCode={videoCode}
          setModalOpen={setModalOpen}
        />
      )}
      <section
        data-datocms-noindex
        className="feature-slider"
        style={{ backgroundColor: bg }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h3 className="text-white oblique">{headline}</h3>
            </div>
            <div className="col-md-6 dots"></div>
          </div>
        </div>
        <div className="featureSliderWrapper offset-lg-1">
          <SlickSlider {...sliderSettings}>
            {featuredSlides?.map(feature => (
              <FeatureCard
                key={feature.headline}
                featureData={feature}
                handleModal={handleModal}
              />
            ))}
          </SlickSlider>
        </div>
      </section>
    </>
  )
}
